export enum ModuleTypeNameEnum {
  AUD = 'AUD',
  CAP = 'CAP',
  CHG = 'CHG',
  DOMAIN = 'DOMAIN',
  INC = 'INC',
  INF = 'INF',
  IR = 'IR',
  ISMS = 'ISMS',
  IT = 'IT',
  POL = 'POL',
  REQ = 'REQ',
  RISK = 'RISK',
  SM = 'SM',
  SOF = 'SOF',
  SVC = 'SVC',
  TPRM = 'TPRM',
  USER = 'USER',
}
